module.exports = __webpack_public_path__ + "media/images/icons/outlined/logout-7e0381ac118ed9bc1f62ff990fa9d735.svg";